import apiClient from '../api';

export const loginLinkedinUser = (data) => apiClient.post('/linkedin/user', data);

export const onboardLinkedinOrg = (data) => apiClient.post('/linkedin/org/onboard', data);